module.exports = "i{\n    vertical-align: middle;\n}\n.errorColor{\n    color: red;\n}\n.nerrorColor{\n    color: blue;\n}"